import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-35-vasudha-madhavan-guest.webp";
import ThumbImg from "../../assets/images/conversations/035.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: vm2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vm2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .vm2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .vm2-hero { padding-top: 60px; padding-bottom: 60px; }
  .vm2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vm2-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .vm2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm2-hero__title.vm2-visible { opacity: 1; transform: translateY(0); }
  /* social share buttons */
  .vm2-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .vm2-hero__social.vm2-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .vm2-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .vm2-hero__social a:hover { opacity: 0.85; }
  .vm2-hero__social a.fb { background: #3B5998; }
  .vm2-hero__social a.li { background: #0077B5; }
  .vm2-hero__social a.tw { background: #1DA1F2; }
  .vm2-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .vm2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vm2-hero__spotify.vm2-visible { opacity: 1; transform: translateY(0); }
  .vm2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .vm2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vm2-hero__right.vm2-visible { opacity: 1; transform: translateY(0); }

  .vm2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .vm2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .vm2-yt-thumb:hover img { opacity: 0.85; }
  .vm2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .vm2-yt-thumb__play img { width: 40px; height: 44px; }
  .vm2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .vm2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .vm2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm2-body.vm2-visible { opacity: 1; transform: translateY(0); }
  .vm2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .vm2-body__para:last-child { margin-bottom: 0; }

  .vm2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vm2-guest.vm2-visible { opacity: 1; transform: translateY(0); }
  .vm2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .vm2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .vm2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .vm2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vm2-inner { padding-left: 32px; padding-right: 32px; }
    .vm2-hero { padding-top: 32px; padding-bottom: 48px; }
    .vm2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vm2-hero__title { font-size: 24px; }
    .vm2-hero__left { gap: 16px; }
    .vm2-hero__social { gap: 10px; }
    .vm2-hero__social a { gap: 10px; font-size:12px;padding: 10px 12px;}
    .vm2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vm2-guest__photo-bg { width: 260px; height: 300px; }
    .vm2-guest__name { font-size: 24px; margin-top: 18px; }
    .vm2-body__para { font-size: 14px; margin-bottom: 12px; }
    .vm2-body { padding-bottom: 48px; }
    .vm2-guest { padding-bottom: 48px; }
    .vm2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vm2-inner { padding-left: 16px; padding-right: 16px; }
    .vm2-hero { padding-top: 51px; padding-bottom: 30px; }
    .vm2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .vm2-hero__left { gap: 30px; }
    .vm2-hero__title { font-size: 30px; }
    .vm2-hero__social { gap: 11px; }
    .vm2-hero__social a { gap: 10px; font-size:15px;padding: 10px 14px;}
    .vm2-body__para { font-size: 16px; margin-bottom: 10px; }
    .vm2-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vm2-guest__photo-bg { width: 100%; height: 386px; }
    .vm2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vm2-body { padding-bottom: 30px; }
    .vm2-guest { padding-bottom: 30px; }
    .vm2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vm2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "S9E9EJanqTc";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vm2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 35 Vasudha Madhavan"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="vm2-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 35 Vasudha Madhavan thumbnail" />
      <div className="vm2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vm2-hero">
      <div className="vm2-inner">
        <div className="vm2-hero__grid">
          <div className="vm2-hero__left">
            <div ref={titleRef} className="vm2-hero__title">
              EP 35 | Financing your EV start up | Vasudha Madhavan
            </div>
            <div ref={socialRef} className="vm2-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" />
                Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" />
                Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" />
                Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="vm2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2yifLLQY3J8Fa8o57VAtoS?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 35 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vm2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vm2-body">
      <div className="vm2-inner">
        <p className="vm2-body__para">
          Today we are speaking with Vasudha Madhavan, the founder and CEO of Ostara Advisors, the first electric mobility and sustainability investment bank. Ostara Advisors has facilitated some of the pioneering investment deals in the sector, such as Greaves' acquisition of Ampere and Altigreen's raising of the largest private equity round in this space in India. Join us for a relaxed and fun conversation as we delve deep into the finance sector of EVs, discuss the various capital raised by EV startups in India, and explore the segments to look forward to in the EV industry.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vm2-guest">
      <div className="vm2-inner">
        <h2 className="vm2-guest__title">Our Guest</h2>
        <div>
          <div className="vm2-guest__photo-bg">
            <img src={GuestImg} alt="Vasudha Madhavan" />
          </div>
          <p className="vm2-guest__name">Vasudha Madhavan</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep35VasudhaMadhavan() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vm2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}